import { getCardEffect } from "../../services/gameLogic";

const SEAL_OF_SILENCE_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 800" width="800" height="800">
  <defs>
    <!-- Background Ethereal Space -->
    <radialGradient id="bgGlow" cx="50%" cy="50%" r="50%">
      <stop offset="0%" stop-color="#0ff" stop-opacity="0.25"/>
      <stop offset="35%" stop-color="#005b8a" stop-opacity="0.8"/>
      <stop offset="80%" stop-color="#001224" stop-opacity="1"/>
      <stop offset="100%" stop-color="#000000" stop-opacity="1"/>
    </radialGradient>

    <!-- Detailed Rich Gold Ring Gradients -->
    <linearGradient id="goldBase" x1="0%" y1="0%" x2="100%" y2="100%">
      <stop offset="0%" stop-color="#ffdd77"/>
      <stop offset="25%" stop-color="#cca333"/>
      <stop offset="50%" stop-color="#7a5518"/>
      <stop offset="75%" stop-color="#c49b33"/>
      <stop offset="100%" stop-color="#4d3309"/>
    </linearGradient>

    <linearGradient id="goldHighlight" x1="100%" y1="0%" x2="0%" y2="100%">
      <stop offset="0%" stop-color="#ffeedd"/>
      <stop offset="40%" stop-color="#eebb44"/>
      <stop offset="100%" stop-color="#4d3300"/>
    </linearGradient>

    <!-- Cloak Fabric (Deep Oceanic Blue/Black, heavily folded) -->
    <linearGradient id="cloakFabric" x1="0%" y1="0%" x2="100%" y2="0%">
      <stop offset="0%" stop-color="#001833"/>
      <stop offset="20%" stop-color="#003366"/>
      <stop offset="50%" stop-color="#006699"/>
      <stop offset="80%" stop-color="#003366"/>
      <stop offset="100%" stop-color="#001122"/>
    </linearGradient>
    
    <linearGradient id="cloakShadow" x1="50%" y1="0%" x2="50%" y2="100%">
      <stop offset="0%" stop-color="#003366"/>
      <stop offset="50%" stop-color="#001833"/>
      <stop offset="100%" stop-color="#00050a"/>
    </linearGradient>

    <!-- Mask Base (Organic Weathered Ivory/Bone) -->
    <radialGradient id="boneMask" cx="50%" cy="40%" r="60%">
      <stop offset="0%" stop-color="#fffafa"/>
      <stop offset="30%" stop-color="#e6e6fo"/>
      <stop offset="60%" stop-color="#a3a3c2"/>
      <stop offset="85%" stop-color="#52527a"/>
      <stop offset="100%" stop-color="#24243d"/>
    </radialGradient>

    <!-- Undead Hand Skin (Slightly purple, necrotic, thin) -->
    <linearGradient id="paleSkin" x1="20%" y1="100%" x2="80%" y2="0%">
      <stop offset="0%" stop-color="#4d4d80"/>
      <stop offset="40%" stop-color="#8a8ac2"/>
      <stop offset="80%" stop-color="#ccccff"/>
      <stop offset="100%" stop-color="#f2f2ff"/>
    </linearGradient>

    <!-- Filters -->
    <filter id="heavyDropShadow" x="-30%" y="-30%" width="160%" height="160%">
      <feDropShadow dx="0" dy="25" stdDeviation="20" flood-color="#000" flood-opacity="0.95"/>
    </filter>

    <filter id="softGlow" x="-50%" y="-50%" width="200%" height="200%">
      <feGaussianBlur stdDeviation="15" result="blur"/>
      <feComposite in="SourceGraphic" in2="blur" operator="over"/>
    </filter>
    
    <filter id="ambientOcclusion" x="-20%" y="-20%" width="140%" height="140%">
        <feGaussianBlur in="SourceAlpha" stdDeviation="10" result="blur"/>
        <feOffset dx="0" dy="10" result="offsetBlur"/>
        <feFlood flood-color="#000" flood-opacity="0.8"/>
        <feComposite in2="offsetBlur" operator="in"/>
        <feMerge>
            <feMergeNode/>
            <feMergeNode in="SourceGraphic"/>
        </feMerge>
    </filter>
    
    <filter id="eyeGlow" x="-50%" y="-50%" width="200%" height="200%">
      <feGaussianBlur stdDeviation="8" result="blur"/>
      <feComposite in="SourceGraphic" in2="blur" operator="over"/>
    </filter>
  </defs>

  <circle cx="400" cy="400" r="400" fill="url(#bgGlow)" />

  <g filter="url(#heavyDropShadow)">
    <circle cx="400" cy="400" r="340" fill="none" stroke="url(#goldBase)" stroke-width="70" />
    <circle cx="400" cy="400" r="340" fill="none" stroke="#000" stroke-width="70" opacity="0.4"/>
    <circle cx="400" cy="400" r="370" fill="none" stroke="url(#goldHighlight)" stroke-width="8" opacity="0.9"/>
    <circle cx="400" cy="400" r="310" fill="none" stroke="url(#goldHighlight)" stroke-width="12" opacity="0.7"/>
    <circle cx="400" cy="400" r="360" fill="none" stroke="#332200" stroke-width="3" opacity="0.6"/>
    <circle cx="400" cy="400" r="320" fill="none" stroke="#221100" stroke-width="5" opacity="0.8"/>
    
    <g fill="#402a00" opacity="0.8">
      <path d="M 380 60 Q 400 45 420 60 Q 410 70 400 65 Q 390 70 380 60 Z M 395 50 A 5 5 0 1 1 405 50 A 5 5 0 1 1 395 50" />
      <path d="M 370 70 L 375 80 L 390 80 Q 400 90 410 80 L 425 80 L 430 70" fill="none" stroke="#402a00" stroke-width="4"/>
      <path d="M 740 380 Q 755 400 740 420 Q 730 410 735 400 Q 730 390 740 380 Z M 750 395 A 5 5 0 1 1 750 405 A 5 5 0 1 1 750 395" />
      <path d="M 730 370 L 720 375 L 720 390 Q 710 400 720 410 L 720 425 L 730 430" fill="none" stroke="#402a00" stroke-width="4"/>
      <path d="M 380 740 Q 400 755 420 740 Q 410 730 400 735 Q 390 730 380 740 Z M 395 750 A 5 5 0 1 1 405 750 A 5 5 0 1 1 395 750" />
      <path d="M 60 380 Q 45 400 60 420 Q 70 410 65 400 Q 70 390 60 380 Z M 50 395 A 5 5 0 1 1 50 405 A 5 5 0 1 1 50 395" />
      
      <g transform="translate(640, 160) rotate(45)">
          <path d="M -15 -15 L 15 15 M -15 15 L 15 -15" fill="none" stroke="#402a00" stroke-width="6"/>
          <circle cx="0" cy="0" r="20" fill="none" stroke="#402a00" stroke-width="4"/>
      </g>
      <g transform="translate(640, 640) rotate(135)">
          <path d="M -20 -10 C 0 -30 20 -10 20 10 C 0 30 -20 10 -20 -10 Z" fill="none" stroke="#402a00" stroke-width="5"/>
          <circle cx="0" cy="0" r="5" />
      </g>
      <g transform="translate(160, 640) rotate(225)">
          <path d="M -15 -15 L 15 15 M -15 15 L 15 -15" fill="none" stroke="#402a00" stroke-width="6"/>
          <circle cx="0" cy="0" r="20" fill="none" stroke="#402a00" stroke-width="4"/>
      </g>
      <g transform="translate(160, 160) rotate(315)">
          <path d="M -20 -10 C 0 -30 20 -10 20 10 C 0 30 -20 10 -20 -10 Z" fill="none" stroke="#402a00" stroke-width="5"/>
          <circle cx="0" cy="0" r="5" />
      </g>
    </g>

    <circle cx="400" cy="400" r="306" fill="#001833"/> 
    <circle cx="400" cy="400" r="306" fill="url(#cloakShadow)" opacity="0.8"/> 

    <g id="Avatar" filter="url(#ambientOcclusion)">
      <path d="M 120 700 C 130 500 200 240 400 90 C 600 240 670 500 680 700 Z" fill="#000714"/>
      <path d="M 400 80 C 250 180 150 400 70 710 C 150 720 250 720 350 710 C 220 500 280 250 400 80 Z" fill="url(#cloakFabric)"/>
      <path d="M 130 715 C 200 500 260 250 400 120 C 300 280 250 500 180 710 C 150 715 130 715 130 715 Z" fill="#001122" opacity="0.8"/>
      <path d="M 400 80 C 550 180 650 400 730 710 C 650 720 550 720 450 710 C 580 500 520 250 400 80 Z" fill="url(#cloakFabric)"/>
      <path d="M 670 715 C 600 500 540 250 400 120 C 500 280 550 500 620 710 C 650 715 670 715 670 715 Z" fill="#001122" opacity="0.8"/>
      <path d="M 200 710 C 250 450 350 350 400 220 C 450 350 550 450 600 710 C 500 720 300 720 200 710 Z" fill="#001a33" opacity="0.9"/>
      <path d="M 280 710 C 300 550 350 450 400 350 C 450 450 500 550 520 710 C 450 715 350 715 280 710 Z" fill="#000a14" opacity="0.95"/>
      <path d="M 400 85 C 240 180 150 400 75 700" fill="none" stroke="#00ffff" stroke-width="8" opacity="0.4" stroke-linecap="round"/>
      <path d="M 400 85 C 560 180 650 400 725 700" fill="none" stroke="#00ffff" stroke-width="8" opacity="0.4" stroke-linecap="round"/>

      <g filter="url(#heavyDropShadow)">
        <path d="M 400 190 
                 C 480 240 540 330 490 480 
                 C 470 540 450 570 420 590
                 C 410 600 390 600 380 590
                 C 350 570 330 540 310 480 
                 C 260 330 320 240 400 190 Z" 
              fill="url(#boneMask)"/>
        <path d="M 330 400 Q 280 480 320 540" fill="none" stroke="#2a2a40" stroke-width="25" stroke-linecap="round" opacity="0.6" filter="url(#softGlow)"/>
        <path d="M 470 400 Q 520 480 480 540" fill="none" stroke="#2a2a40" stroke-width="25" stroke-linecap="round" opacity="0.6" filter="url(#softGlow)"/>
        <path d="M 400 190 Q 400 240 400 300" fill="none" stroke="#ffffff" stroke-width="15" stroke-linecap="round" opacity="0.3"/>
        
        <path d="M 340 370 C 350 300 400 330 385 390 C 375 430 330 460 320 420 C 310 390 330 380 340 370 Z" fill="#03000a" transform="rotate(-15, 340, 370)"/>
        <path d="M 460 370 C 450 300 400 330 415 390 C 425 430 470 460 480 420 C 490 390 470 380 460 370 Z" fill="#03000a" transform="rotate(15, 460, 370)"/>
        <path d="M 345 375 C 350 320 385 340 375 390 C 365 420 335 440 330 410 C 325 390 335 380 345 375 Z" fill="none" stroke="#00ffff" stroke-width="4" opacity="0.3" transform="rotate(-15, 340, 370)"/>
        <path d="M 455 375 C 450 320 415 340 425 390 C 435 420 465 440 470 410 C 475 390 465 380 455 375 Z" fill="none" stroke="#00ffff" stroke-width="4" opacity="0.3" transform="rotate(15, 460, 370)"/>

        <g transform="translate(400, 275) scale(1.4)" filter="url(#eyeGlow)">
          <circle cx="0" cy="0" r="22" fill="#000714" />
          <path d="M -20 0 A 20 20 0 1 1 20 0 A 20 20 0 1 1 -20 0" fill="none" stroke="#001833" stroke-width="6"/>
          <path d="M 0 -12 C 18 -12 18 12 0 12 C -12 12 -12 0 0 0 C 6 0 6 6 0 6" fill="none" stroke="#00ffff" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M 0 -12 C 18 -12 18 12 0 12 C -12 12 -12 0 0 0 C 6 0 6 6 0 6" fill="none" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" opacity="0.9"/>
        </g>

        <g stroke-linecap="round" filter="url(#heavyDropShadow)">
            <path d="M 300 480 Q 260 600 300 700" fill="none" stroke="#4d4d73" stroke-width="18"/>
            <path d="M 500 480 Q 540 600 500 700" fill="none" stroke="#4d4d73" stroke-width="18"/>
            <path d="M 360 560 Q 320 660 380 720" fill="none" stroke="#33334d" stroke-width="22"/>
            <path d="M 440 560 Q 480 660 420 720" fill="none" stroke="#33334d" stroke-width="22"/>
            
            <path d="M 320 500 Q 280 620 330 710" fill="none" stroke="url(#boneMask)" stroke-width="24"/>
            <path d="M 480 500 Q 520 620 470 710" fill="none" stroke="url(#boneMask)" stroke-width="24"/>
            <path d="M 350 530 Q 330 630 370 715" fill="none" stroke="url(#boneMask)" stroke-width="22"/>
            <path d="M 450 530 Q 470 630 430 715" fill="none" stroke="url(#boneMask)" stroke-width="22"/>

            <path d="M 380 570 Q 370 650 395 720" fill="none" stroke="url(#boneMask)" stroke-width="18"/>
            <path d="M 420 570 Q 430 650 405 720" fill="none" stroke="url(#boneMask)" stroke-width="18"/>
            <path d="M 400 580 Q 400 660 410 730" fill="none" stroke="url(#boneMask)" stroke-width="16"/>
        </g>
      </g>


      <g id="Hand" filter="url(#heavyDropShadow)">
        <path d="M 460 760 C 450 680 430 640 400 640 L 370 640 C 370 680 390 740 410 780 Z" fill="url(#paleSkin)"/>
        <path d="M 370 640 C 400 630 440 640 450 670 C 420 700 380 690 370 640 Z" fill="#4d4d80" opacity="0.8"/>
        <path d="M 450 670 C 430 660 410 670 410 685 C 410 700 440 705 455 690 Z" fill="url(#paleSkin)"/>
        <path d="M 430 680 C 430 680 430 690 445 690" fill="none" stroke="#2a2a40" stroke-width="2" stroke-linecap="round" opacity="0.6"/>
        <path d="M 435 680 C 405 665 385 685 385 700 C 385 715 420 720 445 695 Z" fill="url(#paleSkin)"/>
        <path d="M 410 695 C 410 695 410 710 435 710" fill="none" stroke="#2a2a40" stroke-width="2" stroke-linecap="round" opacity="0.6"/>
        <path d="M 425 695 C 390 685 375 705 375 725 C 375 745 410 750 440 720 Z" fill="url(#paleSkin)"/>
        <path d="M 400 715 C 400 715 400 730 430 730" fill="none" stroke="#2a2a40" stroke-width="3" stroke-linecap="round" opacity="0.6"/>

        <path d="M 430 620 C 460 610 470 640 450 670 C 440 690 420 685 405 670 C 400 660 400 630 430 620 Z" fill="url(#paleSkin)"/>
        <path d="M 440 625 L 435 640" stroke="#2a2a40" stroke-width="4" stroke-linecap="round" opacity="0.5"/>
        <path d="M 415 665 C 410 670 405 665 410 660 C 415 655 420 660 415 665 Z" fill="#b3b3cc" opacity="0.8"/>

        <path d="M 400 640 
                 C 395 560 395 480 395 420 
                 C 395 410 405 405 412 410 
                 C 418 420 420 480 420 560
                 C 420 590 415 620 410 640 Z" 
              fill="url(#paleSkin)"/>
              
        <path d="M 390 460 C 395 455 405 450 415 455 C 420 460 425 465 422 470 C 415 470 405 475 395 470 Z" fill="#8a8ac2" opacity="0.7"/>
        <path d="M 392 462 Q 403 468 418 462" fill="none" stroke="#2a2a40" stroke-width="3" opacity="0.7"/> 
        
        <path d="M 392 540 C 397 535 407 530 417 535 C 422 540 425 545 422 550 C 412 550 405 555 395 550 Z" fill="#8a8ac2" opacity="0.7"/>
        <path d="M 395 542 Q 405 548 418 542" fill="none" stroke="#2a2a40" stroke-width="3" opacity="0.7"/>
        
        <path d="M 395 620 Q 405 628 415 620" fill="none" stroke="#2a2a40" stroke-width="4" opacity="0.6"/> 

        <path d="M 398 425 C 398 410 402 400 406 390 C 410 400 413 410 413 425 C 410 435 400 435 398 425 Z" fill="#d9d9f2" stroke="#2a2a40" stroke-width="1.5" opacity="0.95"/>
        <path d="M 400 430 Q 402 460 398 480 M 402 490 Q 404 540 400 560 M 404 570 Q 406 600 402 620" fill="none" stroke="#ffffff" stroke-width="3" stroke-linecap="round" opacity="0.6" filter="url(#softGlow)"/>
      </g>
    </g>
  </g>
</svg>`;

let avatarImageCache: HTMLImageElement | null = null;
function getAvatarImage() {
    if (avatarImageCache) return avatarImageCache;
    const img = new Image();
    const svgBlob = new Blob([SEAL_OF_SILENCE_SVG], { type: 'image/svg+xml;charset=utf-8' });
    const url = URL.createObjectURL(svgBlob);
    img.src = url;
    avatarImageCache = img;
    return img;
}

// Math Utilities
const easeOutQuint = (x: number): number => 1 - Math.pow(1 - x, 5);
const easeInQuint = (x: number): number => x * x * x * x * x;
const lerp = (a: number, b: number, t: number) => a + (b - a) * t;

// 1. Particle Systems for Mist and Ember
class SmokeParticle {
    x: number; y: number; vx: number; vy: number;
    life: number; maxLife: number;
    size: number; rot: number; vrot: number;
    color: string;

    constructor(cx: number, cy: number, isInner: boolean) {
        // Spawn either in a wide ring to drift inward, or central to drift outward
        const angle = Math.random() * Math.PI * 2;
        const dist = isInner ? Math.random() * 50 : 200 + Math.random() * 150;
        this.x = cx + Math.cos(angle) * dist;
        this.y = cy + Math.sin(angle) * dist;

        // Velocity points inward if outer, outward if inner
        const speed = isInner ? 20 + Math.random() * 50 : -(40 + Math.random() * 60);
        this.vx = Math.cos(angle) * speed;
        this.vy = Math.sin(angle) * speed;

        this.size = 20 + Math.random() * 60;
        this.maxLife = 1.0 + Math.random() * 1.5;
        this.life = this.maxLife;
        this.rot = Math.random() * Math.PI * 2;
        this.vrot = (Math.random() - 0.5) * 2;

        const hue = 190 + Math.random() * 30; // Cyan to Deep Blue
        const lum = isInner ? 30 + Math.random() * 40 : 10 + Math.random() * 20;
        this.color = `hsl(${hue}, 100%, ${lum}%)`;
    }

    update(dt: number) {
        this.x += this.vx * dt;
        this.y += this.vy * dt;
        this.rot += this.vrot * dt;
        this.life -= dt;
    }

    draw(ctx: CanvasRenderingContext2D) {
        if (this.life <= 0) return;
        const p = this.life / this.maxLife;
        const alpha = Math.sin(p * Math.PI) * 0.6; // fade in and out

        ctx.save();
        ctx.translate(this.x, this.y);
        ctx.rotate(this.rot);

        const grad = ctx.createRadialGradient(0, 0, 0, 0, 0, this.size);
        grad.addColorStop(0, this.color.replace(')', `, ${alpha})`).replace('hsl', 'hsla'));
        grad.addColorStop(1, this.color.replace(')', `, 0)`).replace('hsl', 'hsla'));

        ctx.fillStyle = grad;
        ctx.globalCompositeOperation = 'screen';
        ctx.beginPath();
        ctx.arc(0, 0, this.size, 0, Math.PI * 2);
        ctx.fill();
        ctx.restore();
    }
}

// 2. Beautiful Spectral Ribbon Physics (like flowing magic silk doing real complex physics loops)
class Point {
    x: number; y: number; oldX: number; oldY: number; pinned: boolean
    constructor(x: number, y: number, pinned = false) {
        this.x = x; this.y = y; this.oldX = x; this.oldY = y; this.pinned = pinned
    }
    update(drag: number) {
        if (this.pinned) return
        const vx = (this.x - this.oldX) * drag
        const vy = (this.y - this.oldY) * drag
        this.oldX = this.x; this.oldY = this.y
        this.x += vx
        this.y += vy
    }
}

class Constraint {
    p1: Point; p2: Point; length: number; stiffness: number
    constructor(p1: Point, p2: Point, length: number, stiffness = 1) {
        this.p1 = p1; this.p2 = p2; this.length = length; this.stiffness = stiffness
    }
    resolve() {
        const dx = this.p1.x - this.p2.x
        const dy = this.p1.y - this.p2.y
        const dist = Math.sqrt(dx * dx + dy * dy)
        if (dist === 0) return
        const diff = (this.length - dist) / dist * this.stiffness
        if (!this.p1.pinned) { this.p1.x += dx * diff * 0.5; this.p1.y += dy * diff * 0.5 }
        if (!this.p2.pinned) { this.p2.x -= dx * diff * 0.5; this.p2.y -= dy * diff * 0.5 }
    }
}

class SpiralRibbon {
    points: Point[] = [];
    constraints: Constraint[] = [];
    baseWidth: number;
    delay: number;
    life: number;
    phaseOffset: number;
    orbitSpeed: number;
    color: string;

    constructor(startX: number, startY: number, delay: number, width: number, lengthNodes: number, phase: number) {
        this.baseWidth = width;
        this.delay = delay;
        this.life = 0;
        this.orbitSpeed = 5 + Math.random() * 3;
        this.phaseOffset = phase;
        this.color = phase % 2 === 0 ? '#00ccff' : '#0055ff';

        for (let i = 0; i < lengthNodes; i++) {
            const p = new Point(startX, startY - i * 5, i === 0);
            this.points.push(p);
            if (i > 0) {
                // High stiffness creates smooth silk
                this.constraints.push(new Constraint(this.points[i - 1], p, 5, 0.98));
            }
        }
    }

    update(dt: number, cx: number, targetY: number) {
        if (this.delay > 0) {
            this.delay -= dt;
            return;
        }
        this.life += dt;
        const t = this.life;

        // 3D Orbital mathematics combined with descent
        // We simulate a 3D orbit around the Y center.
        const descentT = Math.min(1.0, t / 1.5);

        // Starts wide, spirals tight into the target
        const currentRadius = lerp(250, 40, easeOutQuint(descentT));

        // Flattens out the higher it rotates (to simulate z-depth orbit)
        const zScale = 0.2 + (0.3 * (1 - descentT));

        const angle = this.phaseOffset + t * this.orbitSpeed;

        // X spirals in
        const targetX = cx + Math.cos(angle) * currentRadius;
        // Y descends rapidly then halts
        const baseTargetY = lerp(targetY - 400, targetY + 20, easeOutQuint(descentT));
        const orbity = baseTargetY + Math.sin(angle) * currentRadius * zScale;

        // The head chases the target vector precisely
        this.points[0].x = lerp(this.points[0].x, targetX, 0.6);
        this.points[0].y = lerp(this.points[0].y, orbity, 0.6);

        // Wind force adds turbulence and upward drafts to tails making it ethereal
        const windX = Math.sin(t * 3 + this.phaseOffset) * 15;
        const windY = -5;

        // Apply drag based on Z-depth (the math.sin(angle) simulates moving back and forth in Z space)
        // If it's rotating "behind", we increase drag to make it move slower
        const simulatedZ = Math.sin(angle); // 1 = front, -1 = back
        const dynamicDrag = 0.85 - (simulatedZ * 0.05);

        for (let i = 1; i < this.points.length; i++) {
            this.points[i].x += windX * dt;
            this.points[i].y += windY * dt;
            this.points[i].update(dynamicDrag);
        }

        // Solve IK twice for stiffness
        for (let k = 0; k < 2; k++) {
            this.constraints.forEach(c => c.resolve());
        }
    }

    draw(ctx: CanvasRenderingContext2D, baseAlpha: number) {
        if (this.delay > 0 || this.points.length < 2) return;

        // Calculate Z depth to handle pseudo-3D occlusion behind the target later if needed
        // For now, we adjust opacity to fake depth.
        const t = this.life;
        const angle = this.phaseOffset + t * this.orbitSpeed;
        const simulatedZ = Math.sin(angle); // Front vs back of orbit

        ctx.beginPath();
        const left: { x: number, y: number }[] = [];
        const right: { x: number, y: number }[] = [];

        for (let i = 0; i < this.points.length; i++) {
            const p = this.points[i];
            let dx = 0, dy = 1;
            if (i > 0) { dx = p.x - this.points[i - 1].x; dy = p.y - this.points[i - 1].y; }
            else if (i < this.points.length - 1) { dx = this.points[i + 1].x - p.x; dy = this.points[i + 1].y - p.y; }

            const perp = Math.atan2(dy, dx) + Math.PI / 2;
            const prog = i / this.points.length; // 0 at head, 1 at tail
            // Sharp spear point, getting thicker, then trailing off
            let currentWidth = this.baseWidth;
            if (prog < 0.1) currentWidth = lerp(0, this.baseWidth, prog / 0.1);
            else currentWidth = this.baseWidth * Math.pow(1 - prog, 0.7);

            left.push({ x: p.x - Math.cos(perp) * currentWidth, y: p.y - Math.sin(perp) * currentWidth });
            right.push({ x: p.x + Math.cos(perp) * currentWidth, y: p.y + Math.sin(perp) * currentWidth });
        }

        ctx.moveTo(left[0].x, left[0].y);
        for (let i = 1; i < left.length; i++) ctx.lineTo(left[i].x, left[i].y);
        for (let i = right.length - 1; i >= 0; i--) ctx.lineTo(right[i].x, right[i].y);
        ctx.closePath();

        ctx.save();

        // Opacity drops linearly based on ribbon lifespan
        const fadeOut = Math.max(0, 1 - (this.life - 1.5) / 1.5);
        ctx.globalAlpha = baseAlpha * fadeOut;

        // Pseudo 3D darkening for strands that rotate "behind" the target
        if (simulatedZ < 0) {
            ctx.globalAlpha *= 0.4; // Darker and more transparent when behind
        }

        ctx.fillStyle = this.color;
        ctx.shadowColor = this.color;
        ctx.shadowBlur = simulatedZ > 0 ? 25 : 5; // Glowing brightly only when in front
        ctx.globalCompositeOperation = 'screen';
        ctx.fill();
        ctx.restore();
    }
}


export type SealOfSilenceEffectData = {
    kind: 'sealOfSilence';
    t: number;
    sx: number; sy: number;
    tx: number; ty: number;
    data?: SealOfSilenceInternalData;
};

type SealOfSilenceInternalData = {
    isComplete: boolean;
    time: number;
    smoke: SmokeParticle[];
    ribbons: SpiralRibbon[];
    avatarImage: HTMLImageElement;
    safeCY: number;
};

export const createSealOfSilenceEffect = (sx: number, sy: number, tx: number, ty: number): SealOfSilenceEffectData => ({
    kind: 'sealOfSilence',
    t: 0, sx, sy, tx, ty
});

export const renderSealOfSilenceEffect = (
    eff: SealOfSilenceEffectData,
    ctx: CanvasRenderingContext2D
): boolean => {

    if (!eff.data) {
        // ALWAYS CENTER THE MAIN AVATAR IN VIEW, REGARDLESS OF TARGET
        // The effect target (tx, ty) dictates where the locks and ribbons crash down.
        // But the Avatar MUST be visible to look cool. Center X and clamped Center Y.
        const safeMargin = 300; // Large margin due to huge avatar scale
        let safeCY = ctx.canvas.height / 2;

        const smoke: SmokeParticle[] = [];
        for (let i = 0; i < 40; i++) smoke.push(new SmokeParticle(eff.tx, safeCY, false));

        const ribbons: SpiralRibbon[] = [];
        // 8 Ribbons creating an incredibly dense cage effect
        for (let i = 0; i < 8; i++) {
            ribbons.push(new SpiralRibbon(eff.tx, safeCY - 300, 1.4 + i * 0.08, 12, 45, (Math.PI * 2 / 8) * i));
        }

        eff.data = {
            isComplete: false,
            time: 0,
            smoke,
            ribbons,
            avatarImage: getAvatarImage(),
            safeCY
        };
    }

    const dt = 16.7 / 1000;
    eff.data.time += dt;
    const t = eff.data.time;
    // Main spellcaster visual anchor
    const cx = window.innerWidth / 2;
    const cy = eff.data.safeCY;
    const targetY = eff.ty; // Where the chains and locks go
    const targetX = eff.tx;


    // Manage Smoke particles
    if (Math.random() < 0.6 && t < 3.5) {
        eff.data.smoke.push(new SmokeParticle(cx, cy, true));
    }
    for (let i = eff.data.smoke.length - 1; i >= 0; i--) {
        eff.data.smoke[i].update(dt);
        if (eff.data.smoke[i].life <= 0) eff.data.smoke.splice(i, 1);
    }

    // Manage Ribbons
    for (const ribbon of eff.data.ribbons) {
        ribbon.update(dt, targetX, targetY);
    }

    if (t > 4.5) eff.data.isComplete = true;
    if (eff.data.isComplete) return false;

    ctx.save();

    // 1. Vast Ethereal Darkness Background
    let darkAlpha = 0;
    if (t < 1.0) darkAlpha = (t / 1.0) * 0.95;
    else if (t < 3.8) darkAlpha = 0.95;
    else darkAlpha = Math.max(0, 0.95 * (1.0 - (t - 3.8) / 0.7));

    if (darkAlpha > 0) {
        ctx.save();
        const radGrad = ctx.createRadialGradient(cx, cy, 100, cx, cy, 800);
        radGrad.addColorStop(0, `rgba(0, 15, 30, ${darkAlpha})`);
        radGrad.addColorStop(0.5, `rgba(0, 5, 10, ${darkAlpha * 0.9})`);
        radGrad.addColorStop(1, 'rgba(0, 0, 0, 0)');
        ctx.fillStyle = radGrad;
        ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height);
        ctx.restore();
    }

    // 2. Draw Smoke Particles behind
    for (const p of eff.data.smoke) {
        if (p.maxLife > 1.5) p.draw(ctx);
    }

    // 3. Render the Avatar of Silence
    const avatarImg = eff.data.avatarImage;
    if (avatarImg.complete && t < 3.5) {
        ctx.save();
        ctx.translate(cx, cy);

        // Adjust for screen shake triggered by the whisper
        const shockwaveTime = 1.2;
        if (t > shockwaveTime && t < shockwaveTime + 0.8) {
            const sh = 1.0 - (t - shockwaveTime) / 0.8;
            const mag = sh * 15;
            ctx.translate((Math.random() - 0.5) * mag, (Math.random() - 0.5) * mag);
        }

        let scale = 0.65; // Base size
        let alpha = 1;

        if (t < 1.0) {
            const p = easeOutQuint(t / 1.0);
            scale = 0.5 + p * 0.15;
            alpha = p;
            ctx.filter = `blur(${(1 - p) * 20}px) brightness(${1 + (1 - p) * 2})`; // Brilliant flash in
        } else if (t < 3.0) {
            const pulse = (Math.sin(t * 3) + 1) / 2;
            scale = 0.65 + pulse * 0.02;
        } else {
            const p = (t - 3.0) / 0.5;
            alpha = Math.max(0, 1 - p);
            scale = 0.65 - p * 0.1;
            ctx.filter = `blur(${p * 20}px)`;
        }

        ctx.globalAlpha = alpha;
        ctx.scale(scale, scale);
        ctx.drawImage(avatarImg, -400, -400, 800, 800);
        ctx.restore();
    }

    // 4. Foreground Smoke
    for (const p of eff.data.smoke) {
        if (p.maxLife <= 1.5) p.draw(ctx);
    }

    // 5. Muted Shockwave Explosion from target/mouth
    const shockwaveTime = 1.2;
    if (t > shockwaveTime && t < shockwaveTime + 1.2) {
        const p = easeOutQuint((t - shockwaveTime) / 1.2);
        ctx.save();
        ctx.translate(cx, cy);

        // Deep absorbing ring
        ctx.globalCompositeOperation = 'destination-out';
        ctx.beginPath();
        ctx.arc(0, 0, p * 1500, 0, Math.PI * 2);
        ctx.lineWidth = 200 * (1 - p);
        ctx.strokeStyle = `rgba(0,0,0,${1 - p})`;
        ctx.stroke();

        ctx.globalCompositeOperation = 'screen';

        // Highly textured magical geometric shockwave
        for (let r = 0; r < 3; r++) {
            ctx.beginPath();
            ctx.arc(0, 0, p * (1200 - r * 100), 0, Math.PI * 2);
            ctx.lineWidth = 15 * (1 - p) / (r + 1);
            ctx.strokeStyle = `rgba(0, 255, 255, ${1 - p})`;
            if (r > 0) ctx.setLineDash([20, 40]);
            ctx.stroke();
        }

        ctx.restore();
    }

    // 6. Spectral Ribbons 
    const ribbonsAlpha = 1;
    for (const ribbon of eff.data.ribbons) {
        ribbon.draw(ctx, ribbonsAlpha);
    }

    // 7. High-Fidelity Magical Lock slam
    const lockTime = 2.0;
    if (t > lockTime && t < 4.5) {
        const lockP = Math.min(1, easeOutQuint((t - lockTime) / 0.6));
        const fadeP = t > 3.8 ? Math.max(0, 1 - (t - 3.8) / 0.7) : 1;

        ctx.save();
        ctx.translate(targetX, targetY);

        const scale = lerp(4, 1.2, lockP);
        ctx.scale(scale, scale);
        ctx.rotate((1 - lockP) * 0.3); // Slight tilt

        ctx.globalAlpha = lockP * fadeP;

        // Dark, stylized base underneath the glow to give it gravity
        ctx.fillStyle = '#000714';
        ctx.shadowColor = '#000';
        ctx.shadowBlur = 30;

        // Draw a heavy, spiked magical padlock base
        ctx.beginPath();
        ctx.moveTo(-50, -20);
        ctx.lineTo(50, -20);
        ctx.lineTo(60, 30);
        ctx.lineTo(0, 50);
        ctx.lineTo(-60, 30);
        ctx.closePath();
        ctx.fill();

        // Magical Neon Overlays - Ominous Cyan
        ctx.shadowBlur = 25;
        ctx.shadowColor = '#00ffff';

        // Inner glowing border (runic style)
        ctx.lineWidth = 4;
        ctx.strokeStyle = '#00e5ff';
        ctx.beginPath();
        ctx.moveTo(-40, -10);
        ctx.lineTo(40, -10);
        ctx.lineTo(48, 25);
        ctx.lineTo(0, 40);
        ctx.lineTo(-48, 25);
        ctx.closePath();
        ctx.stroke();

        // Diagonal Crossing Lines (The "Seal")
        ctx.lineWidth = 6;
        ctx.strokeStyle = '#00ffff';
        ctx.lineCap = 'round';
        ctx.beginPath();
        ctx.moveTo(-35, -5);
        ctx.lineTo(35, 30);
        ctx.moveTo(35, -5);
        ctx.lineTo(-35, 30);
        ctx.stroke();

        ctx.shadowBlur = 8;
        ctx.strokeStyle = '#ffffff';
        ctx.lineWidth = 2;
        ctx.stroke();

        // Thick Lock Shackle (arc) - more angular and menacing
        ctx.shadowBlur = 20;
        ctx.shadowColor = '#00ffff';
        ctx.beginPath();
        ctx.moveTo(-30, -20);
        ctx.lineTo(-30, -45);
        ctx.lineTo(30, -45);
        ctx.lineTo(30, -20);
        ctx.lineWidth = 8;
        ctx.strokeStyle = '#0055ff'; // Darker blue base for shackle
        ctx.stroke();

        ctx.lineWidth = 3;
        ctx.strokeStyle = '#00ffff'; // Bright cyan highlight
        ctx.stroke();

        // Central Keyhole / Eye symbol
        ctx.fillStyle = '#ffffff';
        ctx.shadowBlur = 15;
        ctx.beginPath();
        ctx.arc(0, 5, 8, 0, Math.PI * 2);
        ctx.moveTo(-4, 10);
        ctx.lineTo(-6, 25);
        ctx.lineTo(6, 25);
        ctx.lineTo(4, 10);
        ctx.fill();

        ctx.restore();

        // Lightburst explicitly on impact
        if (t > lockTime + 0.5 && t < lockTime + 0.8) {
            const impactP = (t - (lockTime + 0.5)) / 0.3;
            ctx.save();
            ctx.translate(targetX, targetY);
            ctx.globalCompositeOperation = 'screen';
            ctx.beginPath();
            ctx.arc(0, 0, 250 * impactP, 0, Math.PI * 2);
            const grad = ctx.createRadialGradient(0, 0, 0, 0, 0, 250 * impactP);
            grad.addColorStop(0, `rgba(0, 255, 255, ${0.8 * (1 - impactP)})`);
            grad.addColorStop(1, 'rgba(0,0,0,0)');
            ctx.fillStyle = grad;
            ctx.fill();
            ctx.restore();
        }
    }

    ctx.restore();
    return true;
};
